import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default class GetAuthorName extends Component {
    constructor(props) {
        super(props);
        this.state = {
            author: null,
            authorLoaded: false,
        };
    }

    componentDidMount() {
        axios.get(this.props.url).then((response) => {
            if (this.refs.refLoaded) {
                this.setState({
                    author: response.data,
                    authorLoaded: true,
                });
            }
        });
    }

    getAuthor() {
        if (this.state.authorLoaded) {
            return (
                <div className="author-wrapper fadeIn">
                    <h3>
                        <span className="authorlink-by">Door</span>
                        <Link
                            className="authorlink"
                            to={{
                                pathname: `/author/${this.state.author.slug}`,
                                state: { transition: 'fade' },
                            }}>
                            {this.state.author.slug}
                        </Link>
                    </h3>
                </div>
            );
        }
    }

    render() {
        return <div ref="refLoaded">{this.getAuthor()}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/GetAuthorName.jsx